import { useEffect, useState } from "react";

export const useShiftKey = () => {
  const [shiftPress, setShiftPress] = useState(false);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.code === "ShiftLeft") {
        setShiftPress(true);
      }
    };
    const onKeyUp = () => {
      setShiftPress(false);
    };

    document.addEventListener("keydown", onKeyDown);
    document.addEventListener("keyup", onKeyUp);
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.removeEventListener("keyup", onKeyUp);
    };
  }, []);

  return shiftPress;
};
